module.exports = __webpack_public_path__ + "img/70100014.5975a1f2.png";